import React from 'react';

function oncelikEtiketi(level) {
  if (level === 'HIGH') return 'YÜKSEK';
  if (level === 'MEDIUM') return 'ORTA';
  return 'DÜŞÜK';
}

export default function ActionPriorityBadge({ priority = 'LOW' }) {
  const level = String(priority || 'LOW').toUpperCase();
  const cls = level === 'HIGH'
    ? 'border-rose-200 bg-rose-50 text-rose-700 dark:border-rose-700 dark:bg-rose-900/20 dark:text-rose-300'
    : level === 'MEDIUM'
      ? 'border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-700 dark:bg-amber-900/20 dark:text-amber-300'
      : 'border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-700 dark:bg-emerald-900/20 dark:text-emerald-300';

  return (
    <span className={`rounded-full border px-2 py-0.5 text-[10px] font-bold ${cls}`}>
      Öncelik: {oncelikEtiketi(level)}
    </span>
  );
}
